import queryString from "query-string";

const query = queryString.parse(window.location.href.split("?")[1] || "");

const ui = {
  state: {
    mapViewTransitioning: false,
    mode: query.mode ? query.mode : "normal",
    share: false
  },

  mutations: {
    setMapViewTransitioning(state, value) {
      state.mapViewTransitioning = value;
    },

    setMode(state, { mode }) {
      state.mode = mode;
    },

    setShare(state, share) {
      state.share = share;
    }
  },

  actions: {
    setMode({ commit }, mode) {
      commit("setMode", {
        mode,
        pushToURL: { mode }
      });
    }
  }
};

export default ui;
